import React from "react";

export const GeographFooter = () => {
  return (
    <>
      <div className="absolute z-20 bottom-0 min-w-full font-bold text-xs md:text-sm lg:text-base text-gray-100 py-1 text-center pointer-events-none">
        &copy; 2021{" "}
        <a
          href="https://www.teikokushoin.co.jp/"
          target="_blank"
          rel="noopener noreferrer"
          className="pointer-events-auto"
        >
          帝国書院
        </a>{" "}
        ＆{" "}
        <a
          href="https://www.kashika.or.jp/geograph/"
          target="_blank"
          rel="noopener noreferrer"
          className="pointer-events-auto"
        >
          都市構造可視化推進機構
        </a>
      </div>
    </>
  );
};
